export const importExcelContainerTypes = {
  '20DC': '20DC',
  '20GP': '20DC',
  '20HC': '20HC',
  '20RF': '20RF',
  '40DC': '40DC',
  '40GP': '40DC',
  '40HC': '40HC',
  '40RF': '40RF',
  '40OT': '40OT',
  '40FR': '40FR',
  '45HC': '45HC',
};
